var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2571",
    "data-name": "Groupe 2571",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 132.108,
    height: 106.745,
    viewBox: "0 0 132.108 106.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2104",
    "data-name": "Rectangle 2104",
    width: 132.108,
    height: 106.745,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2571-2",
    "data-name": "Groupe 2571",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2957",
    "data-name": "Trac\\xE9 2957",
    d: "M66.044,73.977h0A16.292,16.292,0,0,1,49.752,57.685V16.292a16.292,16.292,0,0,1,32.584,0V57.685A16.292,16.292,0,0,1,66.044,73.977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2958",
    "data-name": "Trac\\xE9 2958",
    d: "M66.045,86.774A29.4,29.4,0,0,1,36.683,57.412V39.159a4,4,0,1,1,8,0V57.412a21.361,21.361,0,1,0,42.723,0V39.159a4,4,0,1,1,8,0V57.412A29.4,29.4,0,0,1,66.045,86.774"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2959",
    "data-name": "Trac\\xE9 2959",
    d: "M66.045,106.745a4,4,0,0,1-4-4V82.774a4,4,0,0,1,8,0v19.971a4,4,0,0,1-4,4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2960",
    "data-name": "Trac\\xE9 2960",
    d: "M80.891,106.745H51.2a4,4,0,1,1,0-8H80.891a4,4,0,1,1,0,8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2961",
    "data-name": "Trac\\xE9 2961",
    d: "M105.51,59.885a4,4,0,0,1-2.707-6.946,13.8,13.8,0,0,0,.828-19.472,4,4,0,1,1,5.893-5.411,21.807,21.807,0,0,1-1.309,30.775,3.988,3.988,0,0,1-2.7,1.054",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2962",
    "data-name": "Trac\\xE9 2962",
    d: "M116.012,73.732a4,4,0,0,1-2.707-6.946,33.38,33.38,0,0,0,2.007-47.165A4,4,0,1,1,121.2,14.21a41.38,41.38,0,0,1-2.487,58.468,3.988,3.988,0,0,1-2.705,1.054",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2963",
    "data-name": "Trac\\xE9 2963",
    d: "M26.579,59.885a3.979,3.979,0,0,1-2.7-1.054,21.781,21.781,0,0,1-1.311-30.775,4,4,0,1,1,5.893,5.411,13.781,13.781,0,0,0,.828,19.472,4,4,0,0,1-2.706,6.946",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2964",
    "data-name": "Trac\\xE9 2964",
    d: "M16.076,73.732a3.984,3.984,0,0,1-2.7-1.054A41.428,41.428,0,0,1,10.884,14.21a4,4,0,1,1,5.892,5.411,33.419,33.419,0,0,0,2.007,47.165,4,4,0,0,1-2.707,6.946",
    fill: "#e30613"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.2aad98080eb32eb37b9d180de377b956.svg";
export { ForwardRef as ReactComponent };